//https://codesandbox.io/s/headless-butterfly-6n7xy6?file=/src/RenderWithData.jsx
export const rndInt = () => Math.floor(Math.random() * 1600) + 500;
export const userIDs = [1, 2, 3, 4, 5];
export const apiEndpoint = `https://random-data-api.com/api/v2/users?size=1`;
